import { render, staticRenderFns } from "./TenderDetail.vue?vue&type=template&id=4f1f6b02&"
import script from "./TenderDetail.vue?vue&type=script&lang=js&"
export * from "./TenderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports